import styled from "styled-components";

export const Box2 = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .responsiveRichTextbox {
    height: 42rem;
  }
  .responsiveRichTextbox.quill .ql-editor {
    min-height: 41rem;
    max-height: 41rem;
  }
  @media (max-width: 991px) {
    .responsiveRichTextbox {
      height: 18rem;
    }
    .responsiveRichTextbox.quill .ql-editor {
      min-height: 17rem;
      max-height: 17rem;
    }
    .mBottom1 {
      margin-bottom: 0.5rem;
    }
  }
  @media (max-width: 768px) {
    .responsive768 {
      margin-top: 1rem;
    }
  }
  @media (max-width: 800px) {
  }
  @media (max-width: 768px) {
  }

  .customQuillEditor .ql-toolbar {
  border: none !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.customQuillEditor .ql-container {
  border: none !important;
  background: #ffffff;
}

.customQuillEditor .ql-editor {
  min-height: 100%;
  padding: 18px 18px 24px 18px;
  overflow-y: auto;
}

.customQuillEditor .ql-editor::-webkit-scrollbar {
  width: 8px;
}

.customQuillEditor .ql-editor::-webkit-scrollbar-thumb {
  background: #cfd4dc;
  border-radius: 20px;
}

.customQuillEditor .ql-editor::-webkit-scrollbar-track {
  background: transparent;
}
  #toolbar {
  background: #ffffff !important;
  border: none !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 10px 14px !important;
}

#toolbar .ql-formats {
  margin-right: 10px;
}

#toolbar select,
#toolbar button,
#toolbar span {
  background: transparent !important;
}
`;
